import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { buildAssetUrl } from "@/lib/api";

export default function TradeAttachmentGallery({
  attachments = [],
  onRemove,
  removeDisabled = false,
  imageClassName = "",
}) {
  if (!attachments.length) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {attachments.map((attachment, index) => {
        const attachmentUrl = buildAssetUrl(attachment);

        return (
          <div
            key={`${attachment}-${index}`}
            className="group relative overflow-hidden rounded-2xl border border-primary/20 bg-muted/20"
          >
            <a
              href={attachmentUrl}
              target="_blank"
              rel="noreferrer"
              className="block"
            >
              <img
                src={attachmentUrl}
                alt={`Trade screenshot ${index + 1}`}
                className={`aspect-[4/3] w-full object-cover transition-transform duration-300 group-hover:scale-[1.03] ${imageClassName}`.trim()}
              />
            </a>

            {onRemove ? (
              <Button
                type="button"
                size="icon"
                variant="secondary"
                className="absolute right-2 top-2 h-8 w-8 rounded-full bg-background/85 shadow-sm hover:bg-background"
                onClick={() => onRemove(index)}
                disabled={removeDisabled}
                aria-label={`Remove screenshot ${index + 1}`}
              >
                <X className="h-4 w-4" />
              </Button>
            ) : null}

            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background/90 to-transparent px-3 py-2 text-xs font-medium text-foreground">
              Screenshot {index + 1}
            </div>
          </div>
        );
      })}
    </div>
  );
}
